import { AccountingState, ProductChargingMode } from '@mews-commander/data-access';
import { Amount, ProductOrderCoProduct } from '@mews-commander/types';

/**
 * Product order from the API response
 *
 * See backend: Mews.Server.Web.Components.Serialization.Serializer.SerializeDetailed (data.ProductOrders)
 */
export interface RawProductOrder {
    id: string;
    isCancelled: boolean;
    productId: string;
    product: string;
    consumedUtc: string;
    chargedPerRoomNight: boolean;
    chargedPerPersonStay: boolean;
    chargedPerBedNight: boolean;
    chargedPerPersonPerTimeUnit: boolean;
    chargedPerTimeUnit: boolean;
    nightMultiplier: number;
    unitMultiplier: number;
    personMultiplier: number;
    unitCost: string;
    netUnitCost: string;
    billId: string | null;
    bill: string | null;
    accountingState: AccountingState;
    unitAmount: Amount;
}

export interface ProductOrder {
    id: string;
    multipliers: Multipliers;
    billId: string | null;
    charging: ProductChargingMode;
    consumptionUtc: string | null;
    unitAmount: Amount;
    accountingState: AccountingState;
    data: ProductOrderCoProduct;
    isCanceled: boolean;
    ownerId: string;
}
export interface ProductOrderGroup {
    id: string;
    orders: ProductOrder[];
    bill: string | NoCommonBill;
    consumptionUtc: null | {
        first: string;
        last: string;
    };
    charging: ProductChargingMode;
    totalCost: Amount;
    productId: string | null;
    ageCategoryId: string | null;
    isCanceled: boolean;
    totalNumberOfProducts: number;
    subgroups: ProductOrderGroup[];
}

export enum NoCommonBill {
    Various = 'Various',
    None = 'None',
}

export type Multiplier = 'night' | 'unit' | 'person';

export type Multipliers = Record<Multiplier, number>;

export interface ProductOrdersTotal {
    totalCost: Amount;
    totalNumberOfProducts: number;
}
